// extracted by mini-css-extract-plugin
export var active = "_f9-2";
export var recordingDot = "_f9-1";
export var recordingIndicator = "_f9-0";